import { render, staticRenderFns } from "./payment-frame.vue?vue&type=template&id=1c4f7eea&scoped=true"
import script from "./payment-frame.vue?vue&type=script&lang=js"
export * from "./payment-frame.vue?vue&type=script&lang=js"
import style0 from "./payment-frame.vue?vue&type=style&index=0&id=1c4f7eea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f7eea",
  null
  
)

export default component.exports